// SPDX-License-Identifier: Apache-2.0

import React, { useState } from "react";
import { BiCheck, BiCopy } from "react-icons/bi";

// Small inline copy-to-clipboard button for addresses/outpoints shown
// truncated in the LP tables and forms.
function CopyButton({ value }: { value: string }) {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText(value).then(
      () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      },
      () => console.log("Failed to copy"),
    );
  };

  return (
    <span
      role="button"
      title="Copy"
      onClick={copy}
      style={{ cursor: "pointer", marginLeft: "0.3rem" }}
    >
      {copied ? <BiCheck size={16} /> : <BiCopy size={16} />}
    </span>
  );
}

export default CopyButton;
